import '../css/App.css';
import '../css/main.css';
import React from 'react';
import { Alert, Button, Col, Tabs, Tab, Row, Modal } from 'react-bootstrap';
import { hashHistory } from 'react-router';
import CheckSetComponent from '../components/CheckSetComponent.jsx';
import CheckCardItemDeleteComponent from '../components/CheckCardItemDeleteComponent.jsx';
import FieldGroup from './common/FieldGroup.jsx';
import { authContext } from '../AzureAd';


export default class CheckCardComponent extends React.Component {

    //ChiChun 黃啟鈞 (資訊)
    // operator = authContext.getCachedUser().profile.name;
    //email
    operator = authContext.getCachedUser().userName;

    enterFullScreen() {
        var elem = document.getElementById("root");
        //show full screen 
        elem.webkitRequestFullScreen();
        document.webkitExitFullscreen();
    }

    exitFullScreen() {
        document.webkitExitFullscreen();
    }
    cats;
    constructor(props) {
        super(props);
        this.onTabsChange = this.onTabsChange.bind(this);
    }

    componentWillMount() {
        this.props.changeIsLoadingPage(true);
        this.cats = this.props.view.get('categories');
        if (this.props.previous.get('target')) {
            this.props.reloadCheckCard(this.props.previous.get('target'));
            this.props.findDetails(this.props.previous.get('target'));
        }
        this.props.cleanAlert();
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this.props.cleanAlert();
    }

    onTabsChange(key) {
        this.props.changeCategory(key);
    }

    toSummaryMap(detailArray) {
        let cloth = new Map();
        let pant = new Map();

        for (var index = 0; index < detailArray.length; index++) {
            let detail = detailArray[index];
            let mapKey = detail.checkSet.description;
            let count = 0;
            if (/*cloth*/1 === detail.checkCategory.id) {
                if (undefined === cloth.get(mapKey)) {
                    cloth.set(mapKey, 1);
                } else {
                    count = cloth.get(mapKey);
                    cloth.set(mapKey, 1 + count);
                }
            } else if (/*pant*/2 === detail.checkCategory.id) {
                if (undefined === pant.get(mapKey)) {
                    pant.set(mapKey, 1);
                } else {
                    count = pant.get(mapKey);
                    pant.set(mapKey, 1 + count);
                }
            }
        }

        let ret = [];
        ret.push(cloth);
        ret.push(pant);
        return ret;
    }

    toSummaryTable(detailArray) {
        let countMap = this.toSummaryMap(detailArray);
        let cloth = countMap[0];
        let pant = countMap[1];

        let clothRow = [];
        for (let key of cloth.keys()) {
            clothRow.push('' + key + '(' + cloth.get(key) + ')');
        }
        let pantRow = [];
        for (let key of pant.keys()) {
            pantRow.push('' + key + '(' + pant.get(key) + ')');
        }

        let ret = [];
        ret.push(clothRow);
        ret.push(pantRow);
        return ret;
    }

    toSummaryRows(details, title) {
        let jsxRows = [];

        if (details.length > 0) {
            jsxRows.push((<th key={title}><a>{title}</a> <Button bsStyle="primary" onClick={(event) => { this.showModal(title); }}> - </Button></th>));
            for (let index = 0; index < details.length; index++) {
                jsxRows.push((<td key={index}>{details[index]}</td>));
            }
        }
        return jsxRows;
    }

    d_with = 12 / 4;

    toSetsMap(setArray) {
        /* for grid view: 3 columns */
        let rows = [];
        for (let index = 0; index < setArray.length; index += 4) {
            let map = new Map();
            map.set('left', setArray[index]);
            map.set('middle', setArray[index + 1]);
            map.set('middle-right', setArray[index + 2]);
            map.set('right', setArray[index + 3]);
            rows.push(map);
        }
        return rows;
    }

    checkComplete() {
        let resp = confirm('確認已完成 [' +
            this.props.view.get('card').code +
            this.props.view.get('categories')[this.props.request.get('category')].description + '] 洗前清點?');
        if (resp) {
            if (0 === this.props.request.get('category')) {
                this.props.completeClothChecking(
                    this.props.view.get('card').id,
                    this.props.view.get('card').code,
                    this.operator);
            } else if (1 === this.props.request.get('category')) {
                this.props.completePantChecking(
                    this.props.view.get('card').id,
                    this.props.view.get('card').code,
                    this.operator);
            }
        }

        this.props.reloadCheckCard(this.props.previous.get('target'));
        this.props.resetCheckFileLink(this.props.cases.get('workingTarget') + '');
    }

    checkRestore() {
        let resp = confirm('確認刪除 [' +
            this.props.view.get('card').code +
            this.props.view.get('categories')[this.props.request.get('category')].description + '] 洗前清點資料?');
        if (resp) {
            if (0 === this.props.request.get('category')) {
                this.props.restoreClothChecking(
                    this.props.view.get('card').id,
                    this.props.view.get('card').code,
                    this.operator);
            } else if (1 === this.props.request.get('category')) {
                this.props.restorePantChecking(
                    this.props.view.get('card').id,
                    this.props.view.get('card').code,
                    this.operator);
            }
        }

        this.props.reloadCheckCard(this.props.previous.get('target'));
        this.props.resetCheckFileLink(this.props.cases.get('workingTarget') + '');
    }


    // 標記為建議不再使用
    markAsDiscard() {
        switch (this.props.request.get('category')) {
            case 0:
                this.props.markClothesAsDiscard(
                    this.props.view.get('card').id,
                    this.props.view.get('card').code,
                    this.operator);
                break;
            case 1:
                this.props.markPantAsDiscard(
                    this.props.view.get('card').id,
                    this.props.view.get('card').code,
                    this.operator);
                break;
            default:
                alert('系統錯誤, 動作未能執行');
        }
    }

    // 標記為未送修
    markAsNotDilivered() {
        // 消防衣或消防褲未送修
        let code = this.props.view.get('card').code;
        let category = this.props.request.get('category');
        let noClothes = this.props.view.get('card').noClothes;
        let noPant = this.props.view.get('card').noPant;

        // 衣服
        if (category === 0) {
            // 未標記
            if (!noClothes) {
                let resp = confirm("請再次確認 [ " + code + " ] 並未送修. 確認將移除此筆紀錄.");
                if (!resp) {
                    return;
                }
                this.props.markClothesAsNotDilivered(
                    this.props.view.get('card').id,
                    code,
                    this.operator);
            }
            // 已標記為未送修
            else {
                let resp = confirm("請再次確認取消 [ " + code + " ] 並未送修");
                if (!resp) {
                    return;
                }
                this.props.cancelClothesAsNotDilivered(
                    this.props.view.get('card').id,
                    code,
                    this.operator);
            }
        }
        // 褲子
        else if (category === 1) {
            // 未標記
            if (!noPant) {
                let resp = confirm("請再次確認 [ " + code + " ] 並未送修. 確認將移除此筆紀錄.");
                if (!resp) {
                    return;
                }
                this.props.markPantAsNotDilivered(
                    this.props.view.get('card').id,
                    code,
                    this.operator);
            }
            // 已標記為未送修
            else {
                let resp = confirm("請再次確認取消 [ " + code + " ] 並未送修");
                if (!resp) {
                    return;
                }
                this.props.cancelPantAsNotDilivered(
                    this.props.view.get('card').id,
                    code,
                    this.operator);
            }
        }
        else {
            alert('系統錯誤, 動作未能執行');
        }
    }

    goToMaintenanceCardsPage() {
        hashHistory.push("/maintenanceCards");
    }

    showModal(itemType) {
        this.props.showModal();
        this.props.setRemoveItemType(itemType);
    }

    showPhotoBlk() {
        // let catCode = this.props.request.get('category');
        // this.props.showPhotoBlk();
        this.props.expandContent();
        this.props.changeCheckCardPreviousPage("/maintenanceCard");
        hashHistory.push("/takePhoto");
    }

    showRfidBlk() {
        hashHistory.push("/readRfid");
    }

    hideModal() {
        this.props.hideModal();
    }

    show(show) {
        if (show) {
            return { display: 'block', float: 'left' };
        } else {
            return { display: 'none' };
        }
    }

    show2(show) {
        if (show) {
            return { display: 'inline' };
        } else {
            return { display: 'none' };
        }
    }

    showNote() {
        if (this.props.previousView.get('caseModel') && this.props.previousView.get('caseModel').note) {
            return <span>{this.props.previousView.get('caseModel').note}</span>;
        }
        return '';
    }

    render() {
        let cat = this.cats[this.props.request.get('category')];
        let countMap = this.toSummaryMap(this.props.view.get('details'));

        let noClothes = this.props.view.get('card').noClothes;
        let noPant = this.props.view.get('card').noPant;
        // let cardStatus = this.props.view.get('card').status;
        let c_Checked = this.props.view.get('card').clothesChecked;
        let p_Checked = this.props.view.get('card').pantChecked;
        let epc_cloth = this.props.view.get('card').clothEpc;
        let epc_pant = this.props.view.get('card').pantEpc;
        let preSnap_cloth = this.props.view.get('card').preClothesSnap;
        let preSnap_pant = this.props.view.get('card').prePantSnap;
        let already_discard_clothes = this.props.view.get('card').alreadyDiscardClothes;
        let already_discard_pant = this.props.view.get('card').alreadyDiscardPant;
        let disabledClothesMod = !epc_cloth || "NOT_SET" === epc_cloth || noClothes || already_discard_clothes;
        let notSetClothEpc = !epc_cloth || "NOT_SET" === epc_cloth;
        let disabledPantMod = !epc_pant || "NOT_SET" === epc_pant || noPant || already_discard_pant;
        let notSetPantEpc = !epc_pant || "NOT_SET" === epc_pant;

        let alertDiv = null;
        if (this.props.alert.get('style') || this.props.alert.get('message')) {
            alertDiv = (
                <Alert bsStyle={this.props.alert.get('style')} onDismiss={this.props.cleanAlert}>
                    {this.props.alert.get('message')}
                </Alert>
            );
        }

        let removeDiv = (count) => {
            let hiddenCloth = count[0].size > 0 ? false : true;
            let hiddenPant = count[1].size > 0 ? false : true;

            let noClothes = this.props.view.get('card').noClothes;
            let noPant = this.props.view.get('card').noPant;
            let cat = this.props.request.get('category');

            let hiddenCamera = true;
            if (cat === 0) {
                hiddenCamera = noClothes;
            } else if (cat === 1) {
                hiddenCamera = noPant;
            }

            return <div>
                <a onClick={(event) => { this.showModal("消防衣"); }}
                    hidden={hiddenCloth}>
                    <img alt='remove selected' src='shirt-del.svg' height="30" width="30" style={{ cursor: 'pointer' }} />
                </a>&nbsp;&nbsp;
                <a onClick={(event) => { this.showModal("消防褲"); }}
                    hidden={hiddenPant}>
                    <img alt='remove selected' src='pant-del.svg' height="30" width="30" style={{ cursor: 'pointer' }} />
                </a>&nbsp;&nbsp;
                <a onClick={(event) => { this.showPhotoBlk(); }}
                    hidden={hiddenCamera}>
                    <img alt='拍照' title='拍照' src='camera.svg' height="30" width="30" style={{ cursor: 'pointer' }} />
                </a>&nbsp;&nbsp;&nbsp;
                <a onClick={(event) => { this.showRfidBlk(); }} >
                    <img alt='掃描RFID晶片' title='掃描RFID晶片' src='rfid.svg' height="30" width="30" style={{ cursor: 'pointer' }} />
                </a>
                <span style={{ color: 'red', fontWeight: 'bold', marginLeft: 10 }}>清點前請先拍照和掃描RFID晶片</span>
            </div>
        }

        let showCheckedIcon = (value) => {
            if (value) {
                return 'checked.svg';
            } else {
                return 'checkbox.svg';
            }
        }

        let showClothEpc = (<h4 style={{ color: 'red' }}>EPC: 尚未指定</h4>);
        if (epc_cloth) {
            if ("NOT_SET" === epc_cloth) {
                if ("SKIPPED" === preSnap_cloth) { // 未送修
                    showClothEpc = (<h4 style={{ color: 'green' }}>EPC: 尚未指定</h4>);
                } else {
                    showClothEpc = (<h4 style={{ color: 'red' }}>EPC: 尚未指定</h4>);
                }
            }
            else if (already_discard_clothes) {
                showClothEpc = (<h4 style={{ color: 'orange' }}>EPC: 曾建議不再使用</h4>);
            }
            else if ("NOT_KK_GEAR" === epc_cloth) {
                showClothEpc = (<h4 style={{ color: 'green' }}>EPC: 非開廣消防衣</h4>);
            }
            else if ("UNKNOWN" === epc_cloth) {
                showClothEpc = (<h4 style={{ color: 'green' }}>EPC: 未縫晶片</h4>);
            }
            else {
                showClothEpc = (<h5 style={{ color: 'green' }}>EPC: {epc_cloth}</h5>);
            }
        }

        let showClothPreSnap = (<h4 style={{ color: 'red' }}>尚未拍照</h4>);
        if (preSnap_cloth) {
            if ("SKIPPED" === preSnap_cloth) {
                showClothPreSnap = (<h4 style={{ color: 'green' }}>不需拍照</h4>);
            }
            else if ("UNDONE" === preSnap_cloth) {
                showClothPreSnap = (<h4 style={{ color: 'orange' }}>拍照進行中</h4>);
            }
            else if ("CAPTURED" === preSnap_cloth) {
                showClothPreSnap = (<h4 style={{ color: 'green' }}>已完成拍照</h4>);
            }
        }

        let showPantEpc = (<h4 style={{ color: 'red' }}>EPC: 尚未指定</h4>);
        if (epc_pant) {
            if ("NOT_SET" === epc_pant) {
                if ("SKIPPED" === preSnap_pant) { // 未送修
                    showPantEpc = (<h4 style={{ color: 'green' }}>EPC: 尚未指定</h4>);
                } else {
                    showPantEpc = (<h4 style={{ color: 'red' }}>EPC: 尚未指定</h4>);
                }
            }
            else if (already_discard_pant) {
                showPantEpc = (<h4 style={{ color: 'orange' }}>EPC: 曾建議不再使用</h4>);
            }
            else if ("NOT_KK_GEAR" === epc_pant) {
                showPantEpc = (<h4 style={{ color: 'green' }}>EPC: 非開廣消防褲</h4>);
            }
            else if ("UNKNOWN" === epc_pant) {
                showPantEpc = (<h4 style={{ color: 'green' }}>EPC: 未縫晶片</h4>);
            }
            else {
                showPantEpc = (<h5 style={{ color: 'green' }}>EPC: {epc_pant}</h5>);
            }
        }

        let showPantPreSnap = (<h4 style={{ color: 'red' }}>尚未拍照</h4>);
        if (preSnap_pant) {
            if ("SKIPPED" === preSnap_pant) {
                showPantPreSnap = (<h4 style={{ color: 'green' }}>不需拍照</h4>);
            }
            else if ("UNDONE" === preSnap_pant) {
                showPantPreSnap = (<h4 style={{ color: 'orange' }}>拍照進行中</h4>);
            }
            else if ("CAPTURED" === preSnap_pant) {
                showPantPreSnap = (<h4 style={{ color: 'green' }}>已完成拍照</h4>);
            }
        }

        let pageOpacity = (this.props.isLoadingPage) ? 0.2 : 1;

        return (
            <div style={{ opacity: pageOpacity }}> <span hidden>CheckCardComponent</span>
                <Row>
                    <Col>
                        <h4>
                            <img alt='shorts' src='shorts.svg' height="40" width="40" style={this.show(this.props.request.get('category') === 1)} />
                            <img alt='shirt' src='shirt.svg' height="40" width="40" style={this.show(this.props.request.get('category') === 0)} />
                            &nbsp;清點作業管理 &gt;&gt; 洗前清點 &gt;&gt;&nbsp;
                                {this.props.previousView.get('caseModel').orderId}&nbsp;-&nbsp;{this.showNote()}&nbsp;
                            <a onClick={(e) => { this.goToMaintenanceCardsPage() }}><img src="back.png" title="回上一頁" alt="回上一頁" style={{ cursor: 'pointer' }} /></a>
                        </h4>
                    </Col>
                </Row>
                {alertDiv}
                <Row style={{ marginLeft: -20, marginTop: 10 }}>
                    <Col xs={12} sm={6}>
                        <div>
                            <span className='highlight-Black'>{this.props.view.get('card').code}
                                {this.props.view.get('categories')[this.props.request.get('category')].description}&nbsp;
                                <img alt='shirt_completed' src='shirt-blue.svg' height="20" width="20" style={this.show2(c_Checked)} />
                                <img alt='shirt_not_completed' src='shirt-grey.svg' height="20" width="20" style={this.show2(!c_Checked)} />&nbsp;
                                <img alt='pant_completed' src='pants-blue.svg' height="20" width="20" style={this.show2(p_Checked)} />
                                <img alt='pant_not_completed' src='pants-grey.svg' height="20" width="20" style={this.show2(!p_Checked)} />
                            </span>
                            <Button bsSize="large" style={{ marginLeft: 10 }} bsStyle="info" onClick={(event) => { this.checkComplete() }}>完成清點</Button>
                            <Button bsSize="xsmall" style={{ marginTop: 25, marginLeft: 20 }} onClick={(event) => { this.checkRestore() }}><span style={{ color: '#a94442' }}>刪除清點</span></Button>
                            <span hidden="hidden">&nbsp;&nbsp;
                                <a onClick={e => this.enterFullScreen()}>&nbsp;F&nbsp;</a>/
                                <a onClick={e => this.exitFullScreen()}>&nbsp;S&nbsp;</a>&nbsp;
                                <a href="doc/checking.html" target="_blank">
                                    <img src='question.svg' height="18" width="18" alt='使用手冊' />
                                </a>
                            </span>
                        </div>
                    </Col>
                    <Col xs={12} sm={6}>
                        <div style={{ textAlign: 'right' }}>
                            {removeDiv(countMap)}
                        </div>
                    </Col>
                </Row>
                <Tabs id="ckTabs" defaultActiveKey={this.props.request.get('category')} animation={false} onSelect={this.onTabsChange}>
                    <Tab eventKey={0} title={this.cats[0].description}>
                        <Row>
                            <Col xs={6} sm={3}>
                                <h4>建議不再使用&nbsp;<img alt='shorts' src={showCheckedIcon(this.props.view.get('card').discardClothes)} height="35" width="35" style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                        if (this.props.view.get('card').clothesChecked) {
                                            alert("已完成清點無法標記[建議不再使用]");
                                            return;
                                        }
                                        if (noClothes) {
                                            alert("消防衣未送修，無法建議不再使用");
                                            return;
                                        }
                                        if (notSetClothEpc) {
                                            alert("尚未設定 [消防衣 RFID EPC] 資訊無法紀錄維修履歷，請先設定 RFID 資訊");
                                            return;
                                        }
                                        this.markAsDiscard();
                                    }
                                    } />
                                </h4>
                            </Col>
                            <Col xs={6} sm={3}>
                                <h4>消防衣未送修&nbsp;<img alt='shorts' src={showCheckedIcon(this.props.view.get('card').noClothes)} height="35" width="35" style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                        if (this.props.view.get('card').clothesChecked) {
                                            alert("已完成清點無法標記[未送修]");
                                            return;
                                        }
                                        if (this.props.view.get('card').discardClothes) {
                                            alert("不能同時選取[建議不再使用]與[未送修]");
                                            return;
                                        }
                                        if (countMap[0].size > 0) {
                                            alert("需先移除已清點選項，才能標記[未送修]");
                                            return;
                                        }
                                        this.markAsNotDilivered();
                                    }
                                    } />
                                </h4>
                            </Col>
                            <Col xs={6} sm={2}>
                                {showClothPreSnap}
                            </Col>
                            <Col xs={6} sm={4}>
                                {showClothEpc}
                            </Col>
                        </Row>
                        <div>
                            <Row>
                                <Col xs={12} sm={12} md={12}>
                                    <span>
                                        <FieldGroup
                                            id="note"
                                            label='維修項目額外附註:'
                                            type="text"
                                            value={this.props.request.get('note')}
                                            onChange={(id, value) => {
                                                this.props.setNote(id, value);
                                            }}
                                            maxLength='150'
                                        />
                                    </span>
                                </Col>
                            </Row>
                            {
                                this.toSetsMap(cat.checkSets).map(
                                    (row, index) =>
                                        <Row key={index} className="clearfix" style={{ marginBottom: 1 }}>
                                            <Col xs={this.d_with} sm={this.d_with} md={this.d_with}>
                                                <CheckSetComponent ckset={row.get('left')}
                                                    category={cat}
                                                    countMap={countMap[0]}
                                                    disabled={disabledClothesMod}
                                                    card={this.props.previous.get('target')}
                                                    addCkDetail={(card, category, ckSet, ckItem) => {
                                                        this.props.addCheckDetail(card, epc_cloth, category, ckSet, ckItem, this.props.request.get('note'), this.operator);
                                                    }} />

                                            </Col>
                                            <Col xs={this.d_with} sm={this.d_with} md={this.d_with}>
                                                {undefined === row.get('middle') ? '' :
                                                    <CheckSetComponent ckset={row.get('middle')}
                                                        category={cat}
                                                        countMap={countMap[0]}
                                                        disabled={disabledClothesMod}
                                                        card={this.props.previous.get('target')}
                                                        addCkDetail={(card, category, ckSet, ckItem) => {
                                                            this.props.addCheckDetail(card, epc_cloth, category, ckSet, ckItem, this.props.request.get('note'), this.operator);
                                                        }}
                                                    />
                                                }
                                            </Col>
                                            <Col xs={this.d_with} sm={this.d_with} md={this.d_with}>
                                                {undefined === row.get('middle-right') ? '' :
                                                    <CheckSetComponent ckset={row.get('middle-right')}
                                                        category={cat}
                                                        countMap={countMap[0]}
                                                        disabled={disabledClothesMod}
                                                        card={this.props.previous.get('target')}
                                                        addCkDetail={(card, category, ckSet, ckItem) => {
                                                            this.props.addCheckDetail(card, epc_cloth, category, ckSet, ckItem, this.props.request.get('note'), this.operator);
                                                        }}
                                                    />
                                                }
                                            </Col>
                                            <Col xs={this.d_with} sm={this.d_with} md={this.d_with}>
                                                {undefined === row.get('right') ? '' :
                                                    <CheckSetComponent ckset={row.get('right')}
                                                        category={cat}
                                                        countMap={countMap[0]}
                                                        disabled={disabledClothesMod}
                                                        card={this.props.previous.get('target')}
                                                        addCkDetail={(card, category, ckSet, ckItem) => {
                                                            this.props.addCheckDetail(card, epc_cloth, category, ckSet, ckItem, this.props.request.get('note'), this.operator);
                                                        }} />
                                                }
                                            </Col>
                                        </Row>
                                )
                            }
                        </div>
                    </Tab>
                    <Tab eventKey={1} title={this.cats[1].description}>
                        <Row>
                            <Col xs={6} sm={3}>
                                <h4>建議不再使用&nbsp;<img alt='shorts' src={showCheckedIcon(this.props.view.get('card').discardPant)} height="35" width="35" style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                        if (this.props.view.get('card').pantChecked) {
                                            alert("已完成清點無法標記[建議不再使用]");
                                            return;
                                        }
                                        if (noPant) {
                                            alert("消防褲未送修，無法建議不再使用");
                                            return;
                                        }
                                        if (notSetPantEpc) {
                                            alert("尚未設定 [消防褲 RFID EPC] 資訊無法紀錄維修履歷，請先設定 RFID 資訊");
                                            return;
                                        }
                                        this.markAsDiscard()
                                    }
                                    } />
                                </h4>
                            </Col>
                            <Col xs={6} sm={3}>
                                <h4>消防褲未送修&nbsp;<img alt='shorts' src={showCheckedIcon(this.props.view.get('card').noPant)} height="35" width="35" style={{ cursor: 'pointer' }}
                                    onClick={(e) => {
                                        if (this.props.view.get('card').pantChecked) {
                                            alert("已完成清點無法標記[未送修]");
                                            return;
                                        }
                                        if (this.props.view.get('card').discardPant) {
                                            alert("不能同時選取[建議不再使用]與[未送修]");
                                            return;
                                        }
                                        if (countMap[1].size > 0) {
                                            alert("需先移除已清點選項，才能標記[未送修]");
                                            return;
                                        }
                                        this.markAsNotDilivered()
                                    }
                                    } />
                                </h4>
                            </Col>
                            <Col xs={6} sm={2}>
                                {showPantPreSnap}
                            </Col>
                            <Col xs={6} sm={4}>
                                {showPantEpc}
                            </Col>
                        </Row>
                        <div>
                            <Row>
                                <Col xs={12} sm={12} md={12}>
                                    <span>
                                        <FieldGroup
                                            id="note"
                                            label='維修項目額外附註:'
                                            type="text"
                                            value={this.props.request.get('note')}
                                            onChange={(id, value) => {
                                                this.props.setNote(id, value);
                                            }}
                                            maxLength='150'
                                        />
                                    </span>
                                </Col>
                            </Row>
                            {
                                this.toSetsMap(cat.checkSets).map(
                                    (row, index) =>
                                        <Row key={index} className="clearfix" style={{ marginBottom: 1 }}>
                                            <Col xs={this.d_with} sm={this.d_with} md={this.d_with}>
                                                <CheckSetComponent ckset={row.get('left')}
                                                    category={cat}
                                                    countMap={countMap[1]}
                                                    disabled={disabledPantMod}
                                                    card={this.props.previous.get('target')}
                                                    addCkDetail={(card, category, ckSet, ckItem) => {
                                                        this.props.addCheckDetail(card, epc_pant, category, ckSet, ckItem, this.props.request.get('note'), this.operator);
                                                    }} />
                                            </Col>
                                            <Col xs={this.d_with} sm={this.d_with} md={this.d_with}>
                                                {undefined === row.get('middle') ? '' :
                                                    <CheckSetComponent ckset={row.get('middle')}
                                                        category={cat}
                                                        countMap={countMap[1]}
                                                        disabled={disabledPantMod}
                                                        card={this.props.previous.get('target')}
                                                        addCkDetail={(card, category, ckSet, ckItem) => {
                                                            this.props.addCheckDetail(card, epc_pant, category, ckSet, ckItem, this.props.request.get('note'), this.operator);
                                                        }} />
                                                }
                                            </Col>
                                            <Col xs={this.d_with} sm={this.d_with} md={this.d_with}>
                                                {undefined === row.get('middle-right') ? '' :
                                                    <CheckSetComponent ckset={row.get('middle-right')}
                                                        category={cat}
                                                        countMap={countMap[1]}
                                                        disabled={disabledPantMod}
                                                        card={this.props.previous.get('target')}
                                                        addCkDetail={(card, category, ckSet, ckItem) => {
                                                            this.props.addCheckDetail(card, epc_pant, category, ckSet, ckItem, this.props.request.get('note'), this.operator);
                                                        }}
                                                    />
                                                }
                                            </Col>
                                            <Col xs={this.d_with} sm={this.d_with} md={this.d_with}>
                                                {undefined === row.get('right') ? '' :
                                                    <CheckSetComponent ckset={row.get('right')}
                                                        category={cat}
                                                        countMap={countMap[1]}
                                                        disabled={disabledPantMod}
                                                        card={this.props.previous.get('target')}
                                                        addCkDetail={(card, category, ckSet, ckItem) => {
                                                            this.props.addCheckDetail(card, epc_pant, category, ckSet, ckItem, this.props.request.get('note'), this.operator);
                                                        }} />
                                                }
                                            </Col>
                                        </Row>
                                )
                            }
                        </div>
                    </Tab>
                </Tabs>
                {/*<h4>已選取維修項目摘要:</h4>
                <Table>
                    <tbody><tr>{clothRows}</tr><tr>{pantRows}</tr></tbody>
                </Table>*/}
                <Modal show={this.props.view.get('showModal')} onHide={this.props.hideModal} backdrop="static">
                    <Modal.Header closeButton >
                        <Modal.Title id="remove-checked-item">移除已清點項目</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <CheckCardItemDeleteComponent
                            details={this.props.view.get('details')}
                            itemType={this.props.request.get('itemType')}
                            whenClick={(detailPk, cardPk) => {
                                this.props.removeDetail(detailPk, cardPk);
                                this.props.cleanAlert();
                            }}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={(event) => { this.props.hideModal() }} >離開</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
};



// WEBPACK FOOTER //
// ./src/components/CheckCardComponent.jsx